// --- PATCH GLOBAL SHOPIFY : SUPPRESSION DES DÉCIMALES ---
// Intercepte le formatage officiel des prix et enlève les centimes partout
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    const originalFormat = Shopify.formatMoney;
    Shopify.formatMoney = function(value, format) {
      // Force à enlever les décimales avant l'affichage
      const roundedValue = Math.round(value / 100) * 100; // conversion en centimes
      return originalFormat.call(this, roundedValue, format);
    };
  }
});
